import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'FullButton',
  props: {
        handleClick: Function,
        title: String,
        link: String,
        width: String,
        colour: String,
    },
  setup(__props) {

    const props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: props.link ? props.link : ''
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass(["my-5 py-2 text-center font-medium text-2xl align-middle leading-10 cursor-pointer rounded shadow-lg", 
                __props.colour == 'red' || __props.colour == 'white'
                    ? __props.colour == 'red'
                        ? 'bg-[#db0720] hover:bg-[#ce0720] text-white'
                        : 'bg-[#FFF] hover:bg-[#FAFAFA] text-black border-solid border-[1px] border-black'
                    : 'bg-[#0faedd] hover:bg-[#0fa4dd] text-white'
            ]),
        style: _normalizeStyle('width: ' + props.width + '%;'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (props.handleClick ? props.handleClick() : () => 1))
      }, _toDisplayString(props.title), 7)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})